import { Injectable, TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseControl, Custom, Textbox, TituloProceso } from '@app/shared';

@Injectable()
export class ManageTitlesFormService {
  constructor() { }

  /**
   * Retorna el formulario de modificacion de titulo
   *
   * @param {TituloProceso} [title]
   * @returns {BaseControl<any>[]}
   * @memberof ManageTitlesFormService
   */
  getFields(template: TemplateRef<any>, title?: TituloProceso): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboTipoTitle',
        label: 'Título a remplazar:',
        order: 1,
        value: title ? title.tipo_titulo ? title.tipo_titulo.id: null : null,
        template: template,
        placeholder: 'Seleccionar el titulo a remplazar.',
        validations: {
          validators: [Validators.required],
          messages: {
            required: 'Debe seleccionar un título.'
          }
        }
      }),
      new Textbox({
          key: 'txtNuevoTitulo',
          label: 'Nuevo título:',
          value: title ? title.valor : null,
          order: 2,
          placeholder: 'Ingrese el nuevo título',
          validations: {
            validators: [
                Validators.required
            ],
            messages: {
              required: 'Debe ingresar un título.'
            }
          }
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/manage-titles/shared/manage-titles.form.service.ts